export enum ChatState {
  Ready,
  Loading,
  Error,
}
